import { auth } from '../store/auth'
import http from './http'

export const getProperties = async (id: number) => {
	const res = await http.post('/okno/properties', {
		id_student: id
	})
	return res.data.Properties
}

export const getDescription = async (id: number) => {
	const res = await http.post('/okno-description', {
		id_student: id
	})
	return res.data.data.Description
}

export const getDescriptionTeacher = async (id: number) => {
	const res = await http.post('/teacher/okno-description?id_teacher=' + id)
	return res.data.DescriptionTeacher
}

export const getPayment = async (id: number) => {
	const res = await http.get(`/payment?id_student=${id}`)
	return res.data.data.PAYMENT
}

export const delDescription = async (id: number) => {
	const res = await http.delete(`/description?id_okno_description=${id}`)
	return res.data.data.result
}

export const delDescriptionTeacher = async (id: number) => {
	const res = await http.delete(`/teacher/description-teacher?id_okno_description_teacher=${id}`)
	return res.data.result
}

export const updDescription = async (id: number, idS: number, desc: string) => {
	const res = await http.put(`/description`, {
		id_student: idS,
		id_okno_description: id,
		okno_description: desc
	})
	return res.data.data.result
}

export const updDescriptionTeacher = async (id: number, idT: number, desc: string) => {
	const res = await http.put(`/teacher/description-teacher`, {
		id_teacher: idT,
		id_okno_description_teacher: id,
		okno_description: desc
	})
	return res.data.result
}

export const insDescription = async (id: number, idS: number, desc: string) => {
	const res = await http.put(`/description`, {
		id_teacher: idS,
		id_okno_description_teacher: id,
		id_user: desc
	})
	return res.data.data.result
}

export const getAccessProperty = async (sotrudnikStudent: number) => {
	if (sotrudnikStudent == 1) {
		const res = await http.get('/access/properties?sotrudnikStudent=' + sotrudnikStudent + '&id_AVN_User=' + auth.user.data.id)
		return res.data.AccesToProporties
	}
	if (sotrudnikStudent == 2) {
		const res = await http.get('/access/teacher-properties?sotrudnikStudent=' + sotrudnikStudent + '&id_AVN_User=' + auth.user.data.id)
		return res.data.AccesToProporties
	}
}

export const getTeacherProperty = async (sotrudnikStudent: number) => {
	const res = await http.post('/teacher/okno-properties?id_teacher=' + sotrudnikStudent)
	return res.data.PropertiesTeacher
}

export const getStudentProperty = async (sotrudnikStudent: number) => {
	const res = await http.get('/teacher/okno-properties?id_teacher=' + sotrudnikStudent)
	return res.data.Properties
}

export const getTeacherDesc = async (sotrudnikStudent: number) => {
	const res = await http.post('/teacher/okno-description?id_teacher=' + sotrudnikStudent)
	return res.data.DescriptionTeacher
}

export const getTeacherPhoto = async (sotrudnikStudent: number) => {
	const res = await http.post('/teacher/teacher-photo', {
		id_teacher: sotrudnikStudent
	})
	return res.data.teacherPhoto
}
